import { isObject } from '@frontend/utils';

import type { ResponsePayload } from './types';

export class FetchError extends Error {
  public code?: string;
  public extra?: Record<string, unknown>;

  //originalResponse: added for compatiblility with FetchError in original request.js
  //Some sagas use `originalResponse`, so it is important to preserve it
  public originalResponse?: ResponsePayload;

  get name() {
    return this.constructor.name;
  }
  get [Symbol.toStringTag]() {
    return this.constructor.name;
  }

  constructor(public readonly statusCode: number, payload?: ResponsePayload) {
    const message: string =
      isObject(payload) &&
      'message' in payload &&
      typeof payload.message === 'string'
        ? payload.message
        : statusCode
        ? 'Unknown error.' //status is not 0, but response did not include message
        : 'Request unsent.'; //statusCode is 0 or undefined. Request was made by JS code, but browser did not make request

    super(message);

    if (isObject(payload)) {
      if ('code' in payload && typeof payload.code === 'string') {
        this.code = payload.code;
      }
      if ('extra' in payload && isObject(payload.extra)) {
        this.extra = payload.extra;
      }
    }
    //Note: The origianl FetchError implementation in utils/request.js only defined this.originalResponse if `statusCode`
    if (statusCode) {
      this.originalResponse = payload;
    }
  }
}
